import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { goBackendApi } from 'hooks/api/httpApi';
import { EcomScopesResponseSchema } from '../../pb/responses/v1/ecom_scopes_response_pb';
import { EcomScope } from '../../pb/scopes/v1/ecom_scope_pb';

const getScopes = async (): Promise<EcomScope[]> => {
    const pbClient = new ProtobufClient(goBackendApi());
    return pbClient.getRequest(EcomScopesResponseSchema, '/api/v1/scopes').then((res) => res.scopes);
};

export default {
    getScopes,
};
